export enum TypeExpertise
{
    Interne = 1
}